module.exports = __webpack_public_path__ + "static/media/Icn-wks.69d1e6ec.svg";